import { TextField } from '@carsys/form/src/TextField'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'

const HaynesProFields = () => {
  const { t } = useTranslation()

  return (
    <>
      <Box sx={{ my: 3, maxWidth: 300 }}>
        <TextField data-testid='input-distributor-id' name='HaynesPro.DistributorID' label={t('Field.HaynesPro.DistributorID')} />
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              data-testid='input-company-identification'
              name='HaynesPro.CompanyIdentification'
              label={t('Field.HaynesPro.CompanyIdentification')}
            />
            <TextField
              data-testid='input-distributor-password'
              name='HaynesPro.DistributorPassword'
              label={t('Field.HaynesPro.DistributorPassword')}
            />
            <TextField
              data-testid='input-distributor-client-postfix'
              name='HaynesPro.DistributorClientPostfix'
              label={t('Field.HaynesPro.DistributorClientPostfix')}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField name='HaynesPro.WebserviceDistributorName' label={t('Field.HaynesPro.WebserviceDistributorName')} />
            <TextField name='HaynesPro.WebserviceDistributorPassword' label={t('Field.HaynesPro.WebserviceDistributorPassword')} />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField name='HaynesPro.FallbackIFrameDistributorName' label={t('Field.HaynesPro.FallbackIFrameDistributorName')} />
            <TextField name='HaynesPro.FallbackIFrameDistributorPassword' label={t('Field.HaynesPro.FallbackIFrameDistributorPassword')} />
            <TextField name='HaynesPro.FallbackIFrameUserName' label={t('Field.HaynesPro.FallbackIFrameUserName')} />
            <TextField name='HaynesPro.FallbackIFrameUserType' label={t('Field.HaynesPro.FallbackIFrameUserType')} />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField name='HaynesPro.FallbackWebserviceDistributorName' label={t('Field.HaynesPro.FallbackWebserviceDistributorName')} />
            <TextField
              name='HaynesPro.FallbackWebserviceDistributorPassword'
              label={t('Field.HaynesPro.FallbackWebserviceDistributorPassword')}
            />
            <TextField name='HaynesPro.FallbackWebserviceUserName' label={t('Field.HaynesPro.FallbackWebserviceUserName')} />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default HaynesProFields
